'use client';

import React from 'react';

// Timezone options without LOCAL option (for user timezone selection)
const USER_TIMEZONE_OPTIONS = [
  { value: 'US/Eastern', label: 'Eastern Time' },
  { value: 'US/Central', label: 'Central Time' },
  { value: 'US/Mountain', label: 'Mountain Time' },
  { value: 'US/Pacific', label: 'Pacific Time' },
];

interface UserTimezoneSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
}

const UserTimezoneSelect = ({
  value,
  onChange,
  disabled = false,
  className = '',
  error,
}: UserTimezoneSelectProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={`form-control w-full ${className}`}>
      <label className="label">
        <span className="label-text">Timezone</span>
      </label>
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="select select-bordered w-full">
        {USER_TIMEZONE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <label className="label">
          <span className="label-text-alt text-error">{error}</span>
        </label>
      )}
    </div>
  );
};

export default UserTimezoneSelect;
